import React from 'react'
import toastHot from 'react-hot-toast';
import { Cancel, CheckCircledOutline, InfoEmpty } from 'iconoir-react'

const ToastMessage = ({message, status}) => {
  const color = status === 'fail' ? 'bg-red-500': status === 'success' ? 'bg-green-500': 'bg-blue-500';
  const icon = status === 'fail' ? <Cancel strokeWidth={2} className='border-2 border-gray-500 text-gray-600 h-6 w-6 rounded-full' />
  : status === 'success' ? <CheckCircledOutline strokeWidth={2} className='border-2 border-gray-500 text-gray-600 h-6 w-6 rounded-full' />: 
  <InfoEmpty strokeWidth={2} className='border-2 border-gray-500 text-gray-600 h-6 w-6 rounded-full' />;
  return (
    toastHot.custom(
      <div className={`p-4 ${color} space-x-4 flex items-center rounded-md shadow-md text-gray-100`}>
        {icon}
        <div>
          <p className='mb-1 font-bold text-md capitalize'>{status}</p>
          <p className='mt-1 font-medium text-sm'>{message}</p>
        </div>
      </div>
    )
  )
}

export default ToastMessage